import React, {useState} from "react";
import {useAuth0} from "@auth0/auth0-react";
import "../../App.css";

import { makeStyles } from "@material-ui/core/styles";

//import AlertDialog from "../../blocks/AlertDialog";
//import LoadingProgress from "../../blocks/LoadingProgress";
import PageHeader from "../../blocks/PageHeader.js";
import PageFooter from "../../blocks/PageFooter";

import ShipmentTrackingList from "./components/ShipmentTrackingList";
import ShipmentTrackingForm from "./components/ShipmentTrackingForm";
import ShipmentTrackingMap from "./components/ShipmentTrackingMap";
import ShipmentTrackingAirwaybill from "./components/ShipmentTrackingAirwaybill";
import ShipmentTrackingRouteMap from "./components/ShipmentTrackingRouteMap";

import ShipmentTrackingStyles from "./styles/ShipmentTrackingStyles";

const AccessControl = require ("../../AccessControl");

function ShipmentTracking(props) {
  const classes = makeStyles(ShipmentTrackingStyles)();

  const { isAuthenticated, user } = useAuth0();
  const canEdit = AccessControl.userHasAccess(user, ["Super Admin", "Manage BOOKINGS"]);

  const [state, setState] = useState({
    selectedRecord: null
  });

  const [route, setRoute] = useState(null);

  const changeSelectedRecord = (selectedRecord) => {
    setState({...state, selectedRecord});
  }

  const routeListener = (route) => {
    setRoute(route);
  }

  return (isAuthenticated &&
    <div
      className="CountryPermitRequirements"
      style={{
        backgroundColor: "#eeeeee",
        color: "#1b4481",
        fontWeight: 400,
        fontFamily: "Ubuntu,sans-serif",
        minHeight: "100vh",
      }}
    >
      <PageHeader
        parentProps={props}
        activeMenuItem="shipmenttracking"
        pageName="Track & Trace"
        loggedInUser={user}
        logout={""}
      ></PageHeader>
      <div
        style={{
          marginLeft: 40,
          marginRight: 40,
          height: 2,
          backgroundColor: "#b7c3d4",
        }}
      ></div>
      <div style={{ height: 10 }}></div>

      <div
        className={classes.rooted}
        style={{ display: "table", marginLeft: 20, marginRight: 20, minHeight: `calc(100vh - ${(99+2+10+57+4)}px)` }}
      >
        <div style={{display: "flex"}}>
          <div style={{display: "flex"}}>
            <div style={{display: "inline-flex", width: 370, maxWidth: 370, minWidth: 370}}>
              <ShipmentTrackingList onChangeSelected={changeSelectedRecord} canEdit={canEdit} classes={classes}/>
            </div>
            <div style={{display: "inline-flex", width: "calc(100vw - 690px)", height: "550px", nobackgroundColor: "#ffffff", paddingTop:0}}>
              <ShipmentTrackingMap canEdit={false} record={state.selectedRecord} classes={classes} routeListener={routeListener}/>
              {/* {state.selectedRecord?JSON.stringify(state.selectedRecord, null, 2):'Nothing Selected'} */}
            </div>
          </div>
        </div>
        <div style={{ display: "block", height: 10 }}></div>
        <div>
          <div style={{marginLeft: 20, marginRight: 20, display: "block", paddingTop:0, borderBottom: "1px solid #808080"}}>
            <ShipmentTrackingAirwaybill canEdit={false} record={state.selectedRecord} classes={classes} route={route}/>
            {/* {state.selectedRecord?JSON.stringify(state.selectedRecord, null, 2):'Nothing Selected'} */}
          </div>
        </div>
        <div style={{ display: "block", height: 10 }}></div>
        <div>
          <div style={{marginLeft: 20, marginRight: 20, display: "block", paddingTop:0, borderBottom: "1px solid #808080"}}>
            <ShipmentTrackingRouteMap canEdit={false} record={state.selectedRecord} classes={classes} route={route}/>
            {/* {state.selectedRecord?JSON.stringify(state.selectedRecord, null, 2):'Nothing Selected'} */}
          </div>
        </div>
        <div style={{ display: "block", height: 2 }}></div>
        <div>
          <div style={{marginLeft: 20, display: "block", width: "100%" , height: "500px", paddingTop:0}}>
            <ShipmentTrackingForm canEdit={false} record={state.selectedRecord} classes={classes}/>
            {/* {state.selectedRecord?JSON.stringify(state.selectedRecord, null, 2):'Nothing Selected'} */}
          </div>
        </div>
      </div>
      <PageFooter></PageFooter>
    </div>
  );
}

export default ShipmentTracking;
